import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";
import axios from 'axios';

function Rank() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [analytics, setAnalytics] = useState([]);
  const [tabelLoading, setTableLoading] = useState(false);
  const [deposits, setDeposits] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [user_id, setUserID] = useState("");
  const [client_id, setClientId] = useState("");
  const [deposit_asset, setSepositAsset] = useState("");
  const [network_type, setNetworkType] = useState("");
  const [from_address, setFromAddress] = useState("");
  const [txn_hash, setTxnHash] = useState("");
  const [txnstatus, setStatus] = useState("");
  const [per_page, setPerPage] = useState("");
  const [viewData, setViewData] = useState("");


  const [editPaidAmount, setEditPaidAmount] = useState("");
  const [editFromAddress, setEditFromAddress] = useState("");
  const [editToAddress, setEditToAddress] = useState("");
  const [editTxnHash, setEditTxnHash] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [deposit_id, setDepositId] = useState([]);
  const [error, setError] = useState("");
  const [isRank, setRank] = useState(true)
  const [RankList, setRankList] = useState([])

  const [achiverAnalytics, setAchiverAnalytics] = useState([])
  const [achiverList, setAchiverList] = useState([])
  const [userName, setUserName] = useState("");
  const [rankname, setRankName] = useState("");



  useEffect(() => {

    fetchedAchivers(1);
    fetchRankList();
  }, []);


  const fetchedAchivers = async (page) => {
    console.log('Token ', authToken);

    const searchData = {
      page: page,
      name: userName,
      rank_name: rankname,
      per_page: 10,
    };

    console.log('Reach Data', searchData);

    try {
      const achivers = await fetch(`${baseurl}/rank-rewards`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(searchData),
      });

      if (achivers.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return; // Stop further processing
      }


      const achiversResult = await achivers.json();
      console.log('Achiver data', achiversResult);

      if (achiversResult.status) {
        setAchiverAnalytics(achiversResult.analytics);
        setAchiverList(achiversResult.data);
        setTableLoading(true)
      }
      else {
        setAchiverAnalytics([])
        setTableLoading(true)
      }


    } catch (error) {
      console.error('Fetch error:', error);
    }
  };


  const passData = (depositData) => {
    setDepositId(depositData);
    setViewData(depositData);
    setEditPaidAmount(depositData.paid_amount);
    setEditFromAddress(depositData.from_address);
    setEditToAddress(depositData.to_address);
    setEditTxnHash(depositData.txn_hash);
    setEditStatus(depositData.txn_hash);
  };



  const fetchRankList = async () => {
    try {
      const response = await axios.get(`${baseurl}/rank-list`, {
        headers: {
          Authorization: `Bearer ${authToken}`, // Replace with actual token
        },
      });

      if (response.data.status) {
        console.log("Rank list fetched:", response.data.data);

        setRankList(response.data.data);
        // You can store it in state if using React
        // setRankList(response.data.data);
      } else {
        console.error("Failed:", response.data.message);
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching rank list:", error);
      alert(error.response?.data?.message || "Request failed");
    }
  };






  const handlePageChange = async (page) => {

    setTableLoading(false)
    fetchedAchivers(page);
  }

  const searchData = () => {

    setTableLoading(false)
    fetchedAchivers(1);
  }
  return (
    <>
      <Header>
        <Auth />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Rank!</h4>

              </div>
            </div>
            {/* End Page Header */}

            {/* row */}
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-primary-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL ACHIVERS</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {achiverAnalytics ? achiverAnalytics.total_rank_achiever : '0'}

                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline" />
                </div>
              </div>

              <div className="col-xl-6 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL REWARD</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            ${achiverAnalytics ? achiverAnalytics?.total_rank_reward : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline4" />
                </div>
              </div>

            </div>

            <div className="mt-3 mb-3">
              <button className="btn btn-primary btn-sm" onClick={() => setRank(true)}>Rank List</button> <button className="btn btn-primary btn-sm" onClick={() => setRank(false)}>Achiver List</button>
            </div>

            {isRank ?

              <div className="row">
                <div className="col-md-12 col-lg-12 col-xl-12">
                  <div className="card card-table">
                    <div className=" card-header p-0 d-flex justify-content-between mt-3">
                      <h3 className="card-title mb-1 text-primary">Rank List</h3>
                    </div>
                    <div className="table-responsive country-table">
                      {tabelLoading ? (
                        <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                          <thead>
                            <tr>
                              <th className="wd-lg-25p">Image</th>
                              <th className="wd-lg-25p">Name</th>
                              <th className="wd-lg-25p">Business</th>
                              <th className="wd-lg-25p">Left Business</th>
                              <th className="wd-lg-25p">Right Business</th>
                              <th className="wd-lg-25p">Reward</th>
                              <th className="wd-lg-25p">Condition</th>

                            </tr>
                          </thead>

                          <tbody>
                            {RankList.length > 0 ? (
                              RankList.map((ranks, index) => (
                                <tr key={index}>
                                  <td> <img className="rounded-circle" width={37} src={ranks.rank_image || 'https://apiuser.ride2luxury.in/images/profileImage/avtarImage-1.avif'} /></td>
                                  <td> {ranks.rank_name || 'N/A'} </td>
                                  <td> ${ranks.team_business || '0'} </td>
                                  <td> ${ranks.left_business || '0'} </td>
                                  <td> {ranks.right_business || '0'} </td>
                                  <td> ${ranks.reward || '0'} </td>
                                  <td> ${ranks.conditions || '0'} </td>


                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      ) : (
                        <div className="text-center">
                          <div class="d-flex justify-content-center mb-4">
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </div>
                      )}


                    </div>
                  </div>
                </div>
              </div>
              :
              <>
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-xl-12">
                    <div className="card card-table ">
                      <div className="row">

                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                          <div className="mt-3 ">
                            <lavel>User Name</lavel>
                            <input type="text" value={userName} onChange={(e) => setUserName(e.target.value)} className="form-control" placeholder="Enter User Name" />
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                          <div className="mt-3 ">
                            <lavel>Rank Name</lavel>
                            <input type="text" value={rankname} onChange={(e) => setRankName(e.target.value)} className="form-control" placeholder="Enter Rank Name" />
                          </div>
                        </div>


                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                          <div className="mt-3 text-end">

                            <button onClick={searchData} className="btn btn-primary btn-block mt-3">Search Data</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* row closed */}

                {/* row opened */}
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-xl-12">
                    <div className="card card-table">
                      <div className=" card-header p-0 d-flex justify-content-between mt-3">
                        <h3 className="card-title mb-1 text-primary">Achivers History</h3>
                      </div>
                      <div className="table-responsive country-table">
                        {tabelLoading ? (
                          <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                            <thead>
                              <tr>
                                <th className="wd-lg-25p">Rank</th>
                                <th className="wd-lg-25p">User Name</th>
                                <th className="wd-lg-25p">Rank</th>
                                <th className="wd-lg-25p">Self Stake</th>
                                <th className="wd-lg-25p">Active Referra</th>
                                <th className="wd-lg-25p">Direct Business</th>
                                <th className="wd-lg-25p">Team Business</th>
                                <th className="wd-lg-25p">Reward</th>
                                <th className="wd-lg-25p">Bonus</th>
                                <th className="wd-lg-25p">Date Time</th>
                                <th className="wd-lg-25p">STATUS</th>
                              </tr>
                            </thead>

                            <tbody>
                              {achiverList.length > 0 ? (
                                achiverList.map((achivers, index) => (
                                  <tr key={index}>
                                    <td> <img className="rounded-circle" width={37} src={achivers?.rank_image || 'https://apiuser.ride2luxury.in/images/profileImage/avtarImage-1.avif'} /></td>
                                    <td> {achivers.user_name || 'N/A'} </td>
                                    <td> {achivers.rank_name || '0'} </td>
                                    <td> ${achivers.slef_stake || '0'} </td>
                                    <td> {achivers.direct_referral || '0'} </td>
                                    <td> ${achivers.direct_business || '0'} </td>
                                    <td> ${achivers.business || '0'} </td>
                                    <td> ${achivers.reward || '0'} </td>
                                    <td> ${achivers.bonus || '0'} </td>
                                    <td> {achivers.date_time || 'N/A'} </td>
                                    <td>
                                      {achivers && achivers.status
                                        ? achivers.status === 'success' ? (
                                          <span className="badge bg-success">success</span>
                                        ) : (
                                          <span className="badge bg-danger">{achivers.status} </span>
                                        ) : 'N/A'}
                                    </td>
                                    <td>

                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td>No Data Found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        ) : (
                          <div className="text-center">
                            <div class="d-flex justify-content-center mb-4">
                              <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          </div>
                        )}


                      </div>
                      <div class="gridjs-footer">
                        <div class="gridjs-pagination">
                          <div role="status" aria-live="polite" class="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                          <div className="gridjs-pages text-end">
                            {/* Previous Button */}
                            <button tabIndex="0" role="button" title="Previous" aria-label="Previous" className={pagination.current_page === 1 ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1}> Previous</button>

                            {/* First Page */}
                            <button tabIndex="0" role="button" className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`} title="Page 1" aria-label="Page 1" onClick={() => handlePageChange(1)}> 1</button>

                            {/* Ellipsis if needed */}
                            {pagination.current_page > 3 && <span>...</span>}

                            {/* Middle Pages (2 dynamic pages around current) */}
                            {Array.from({ length: 5 }, (_, i) => {
                              const page = pagination.current_page - 2 + i;
                              if (page > 1 && page < pagination.last_page) {
                                return (
                                  <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`}
                                    aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                    {page}
                                  </button>
                                );
                              }
                              return null;
                            })}

                            {/* Ellipsis if needed */}
                            {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                            {/* Last Page */}
                            {pagination.last_page > 1 && (
                              <button tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`}
                                onClick={() => handlePageChange(pagination.last_page)}>
                                {pagination.last_page}
                              </button>
                            )}

                            {/* Next Button */}
                            <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                              Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            }



          </div>
        </div>


        <ToastContainer />
      </Header>


      <Footer />

    </>
  )
}

export default Rank